module.exports = __webpack_public_path__ + "img/concepcion.33280605.jpg";